// extracted by mini-css-extract-plugin
export default {"container":"NewsTab_container__f9+hi","loader":"NewsTab_loader__ooxtN"};